<template>
  <div v-if="lead.sync_status == 'not_sync_ready'" class="crm-status" :class="'crm-status-' + lead.sync_status  + ' ' + lead.sync_disabled">
    <div>
      <img class="info-icon" src="../../../../assets/info.svg">
      <p class="missing-message">{{$t('models.project_lead.sync_missing_fields')}}</p>
      <div class="crm-status--missing-fields missing-fields" v-if="missingFieldsString">
        <span>{{missingFieldsString}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [ 'lead', 'structure' ],
  computed: {
    missingFieldsString(){
      if(this.lead.missing_attributes_lead_mask){
        let str = ""
        this.lead.missing_attributes_lead_mask.forEach((value) => {
          let field = this.structure[value]

          if(value[1] != null){
            str += value[1] + ", "
          }else{
            // fallback to i18n file if the label is not set in the lead mask
            str += this.$t('models.project_lead.'+ value[0]) + ", "
          }
        })
        return str.slice(0,-2)
      }else{
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.crm-status{
  display: flex;
  text-align: left;
  align-items: center;
  margin-top: 12px;
}
.crm-status-not_synced{
  color: #959595;
}
.crm-status-not_sync_ready{
  color: #959595;
  .crm-status--title{
    color: #2d2d2d;
  }
}
.crm-status-processing{
  color: #007ACE;
}
.crm-status-sync_ready{
  color: #EDC200;
}
.crm-status-sync_ready.false{
  color: #EDC200;
}
.crm-status-sync_error{
  color: #d00019;
}
.crm-status-synced{
  color: #50b83C;
}
.crm-status--icon{
  float: left;
  i {
    font-size: 20px;
  }
}
.crm-status--title{
  padding-left: 5px;
  font-size: 12px;
  font-weight: $font-medium;
}

.missing-message {
    color: #9C6F19;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    display: inline;
}

.info-icon {
  display: inline;
  margin-right: 10px;
}
.crm-status--missing-fields{
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  color: #636A81;
  margin-top: 10px;
  display: inline;
}
</style>



// WEBPACK FOOTER //
// LeadUpdateCrmStatus.vue?b18364d0